// eslint-disable-next-line import/prefer-default-export
export const alertDetailsModalTypes = {
  // TEST_ACTION: 'TEST_ACTION',
  // TEST_CONFIRM: 'TEST_CONFIRM',
  DELETE_ACTION: 'DELETE_ACTION',
  DELETE_COMMENT: 'DELETE_COMMENT',
  DELETE_ALERT: 'DELETE_ALERT',
  ACKNOWLEDGE_ALERT: 'ACKNOWLEDGE_ALERT',
  // CLOSE: 'CLOSE',
};
